import React, { FC } from 'react'
import {
  IHistoryTableData,
  IHistoryTableRow,
  IRecapHistoryRafQty,
} from '../../../../interfaces/IHistory'
import { useHistoryTotal } from '../../../../hooks/history/useHistoryTotal'
import { HISTORY_QUARTER_INITIAL_STATE_TOTAL } from '../../../../__mocks__/historyMock'
import { TYPE_SUMMARY, VIEW_TYPE } from '../../../../constants/tables'
import { isEmptyObj } from '../../../../utils/helpers'
import { QuarterTableRow } from './QuarterTableRow'

export const QuarterTableContent: FC<IHistoryTableData> = ({
  data,
  clientId,
}) => {
  const { summaryTotal, rafQty, totalRafQty } = useHistoryTotal(
    data,
    clientId,
    VIEW_TYPE.QUARTERLY,
    HISTORY_QUARTER_INITIAL_STATE_TOTAL
  )

  return (
    <>
      {!!data?.length && !isEmptyObj(summaryTotal) && (
        <QuarterTableRow
          currentYear={summaryTotal.currentYear}
          previousYear={summaryTotal.previousYear}
          customClass="fontBold backgroundSecondaryLight"
          rafQty={totalRafQty}
        />
      )}
      {!!data?.length &&
        data.map(
          (
            { type, name, currentYear, previousYear }: IHistoryTableRow,
            index
          ) => (
            <QuarterTableRow
              key={index.toString()}
              currentYear={currentYear}
              previousYear={previousYear}
              name={name}
              customClass={`${
                type === TYPE_SUMMARY && 'fontBold backgroundNeutralLight'
              }`}
              rafQty={rafQty ? (rafQty[index] as IRecapHistoryRafQty)?.qty : 0}
            />
          )
        )}
    </>
  )
}
